import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaPhp,
  FaFigma,
} from "react-icons/fa";
import {
  SiTailwindcss,
  SiBootstrap,
  SiLaravel,
  SiMysql,
  SiVite,
  SiGit,
} from "react-icons/si";

export const skillGroups = [
  {
    title: "Front-End",
    caption: "Interfaces people actually enjoy using.",
    items: ["React", "JavaScript", "Tailwind CSS", "HTML5", "CSS3", "Bootstrap"],
  },
  {
    title: "Back-End",
    caption: "Structure, data and logic that hold up.",
    items: ["Laravel", "PHP", "MySQL", "REST APIs", "Auth & Roles", "Eloquent"],
  },
  {
    title: "Craft & Tools",
    caption: "How the work gets shipped.",
    items: ["Git & GitHub", "Vite", "Figma", "UI/UX", "Responsive Design", "Agile"],
  },
];

export const skillMarquee = [
  { icon: FaReact, name: "React" },
  { icon: SiLaravel, name: "Laravel" },
  { icon: FaJs, name: "JavaScript" },
  { icon: SiTailwindcss, name: "Tailwind" },
  { icon: SiMysql, name: "MySQL" },
  { icon: FaPhp, name: "PHP" },
  { icon: FaHtml5, name: "HTML5" },
  { icon: FaCss3Alt, name: "CSS3" },
  { icon: SiBootstrap, name: "Bootstrap" },
  { icon: SiVite, name: "Vite" },
  { icon: SiGit, name: "Git" },
  { icon: FaFigma, name: "Figma" },
];
